import { ISchool } from '../../../interfaces/school.interface'
import { Button, Grid, IconButton, Typography } from '@mui/material'
import Close from '@mui/icons-material/Close'
import React from 'react'
import { AnalyticService } from '../../../lib/analytics/analyticService'
import { useTheme } from '@mui/material/styles'

export default function SchoolHomePageNotificationBanner(props: {
  schoolDetails: ISchool
  additionalStyles?: React.CSSProperties
}) {
  const [state, setState] = React.useState('block')
  const theme = useTheme()

  const handleClose = () => {
    setState('none')
    AnalyticService.onHighlightBannerClose()
  }

  const handleClick = () => {
    AnalyticService.onHighlightBannerClicked()
  }

  if (!props.schoolDetails?.banner_text) {
    return <div />
  }

  return (
    <div style={{ ...props.additionalStyles }}>
      <Grid
        style={{
          width: '100%',
          // backgroundColor: "#a01b35",
          background: `linear-gradient(to right, ${theme.palette.primary.dark}, ${theme.palette.warning.dark})`,
          color: 'white',
          textDecorationColor: 'white',
          paddingTop: '15px',
          paddingLeft: '15px',
          paddingRight: '15px',
          paddingBottom: '15px',
          // borderRadius: "8px",
          textAlign: 'center',
          display: state,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography
            component={'div'}
            align={'center'}
            style={{ color: '#fff', fontWeight: 'bold', margin: 'auto' }}
            onClick={handleClick}
          >
            {props.schoolDetails?.banner_text}
            {props.schoolDetails?.banner_button_link && (
              <Button
                variant={'contained'}
                size={'small'}
                disableElevation={true}
                style={{ marginLeft: '10px' }}
                target={'_blank'}
                href={props.schoolDetails?.banner_button_link}
              >
                {props.schoolDetails?.banner_button_text ||
                  props.schoolDetails?.banner_button_link}
              </Button>
            )}
          </Typography>

          <IconButton size={'small'} onClick={handleClose}>
            <Close style={{ color: '#fff' }} fontSize={'small'} />
          </IconButton>
        </div>
      </Grid>
    </div>
  )
}
